import { toast } from 'sonner';
import { ALL_TASK_VIEW_FLAGS, type TaskViewFlags } from '../../lib/tasks/taskViews';
import {
  useTaskViewFlags,
  useUpdateTaskViewFlags,
} from '../../hooks/queries/useCabinetSettings';
import { cn } from '../../lib/cn';

const OPTIONS: { key: keyof TaskViewFlags; label: string }[] = [
  { key: 'list', label: 'Liste' },
  { key: 'board', label: 'Kanban' },
  { key: 'calendar', label: 'Calendrier' },
];

export function TaskViewFlagsSection() {
  const { data: flags = ALL_TASK_VIEW_FLAGS } = useTaskViewFlags();
  const update = useUpdateTaskViewFlags();
  const enabledCount = OPTIONS.filter((o) => flags[o.key]).length;

  function toggle(key: keyof TaskViewFlags, checked: boolean) {
    const next: TaskViewFlags = { ...flags, [key]: checked };
    if (!next.list && !next.board && !next.calendar) return;
    update.mutate(next, {
      onError: (err) => {
        toast.error(
          err instanceof Error ? err.message : 'Impossible d’enregistrer les vues',
        );
      },
    });
  }

  return (
    <section className="rounded-cime border border-neutral-200 bg-white p-4 space-y-3">
      <div>
        <h2 className="text-lg font-semibold text-cime-text-primary">Affichage</h2>
        <p className="text-sm text-cime-text-muted mt-1">
          Vues proposées sur l’onglet Tâches d’un dossier et sur la page Tâches. Si une
          seule case est cochée, le sélecteur Liste / Kanban / Calendrier disparaît.
        </p>
      </div>
      <div className="flex flex-col gap-2">
        {OPTIONS.map(({ key, label }) => {
          const checked = flags[key];
          const lastOn = checked && enabledCount === 1;
          return (
            <label
              key={key}
              htmlFor={`task-view-${key}`}
              className={cn(
                'flex items-center gap-3 rounded-md border p-3',
                lastOn ? 'cursor-not-allowed opacity-70' : 'cursor-pointer',
                checked ? 'border-cime-primary bg-cime-primary/5' : 'border-neutral-200',
              )}
            >
              <input
                id={`task-view-${key}`}
                type="checkbox"
                className="h-4 w-4 accent-cime-primary"
                checked={checked}
                disabled={lastOn || update.isPending}
                onChange={(e) => toggle(key, e.target.checked)}
              />
              <span className="text-sm font-medium text-cime-text-primary">{label}</span>
            </label>
          );
        })}
      </div>
    </section>
  );
}
